import React, { useContext } from 'react'

import { useSelector } from 'react-redux'

import { ConnectedTrackedRoute } from '@components/UI/TrackedRoute'
import { CampaignContext } from '@context/Campaign'
import { useSubmission } from '@context/Submission'
import { EventTrackingNames } from '@enums'
import { IApplicationState } from '@store'
import { selectLicenseOriginalMediaUrl } from '@store/mediaObjects'
import { Link } from '@tribegroup'
import { LicensingButton } from './Button'

interface IDownloadButton {
  mediaObjectId: number
  children: React.ReactNode
}

export const DownloadButton: React.FC<IDownloadButton> = ({ mediaObjectId, children }) => {
  const { campaign } = useContext(CampaignContext)
  const { submission } = useSubmission()
  const licenseOriginalMediaUrl = useSelector((state: IApplicationState) =>
    selectLicenseOriginalMediaUrl(state, mediaObjectId),
  )

  return (
    <ConnectedTrackedRoute
      eventName={EventTrackingNames.DownloadLicensedContent}
      submissionId={submission?.id}
      campaignId={campaign?.id}
      mediaObjectId={mediaObjectId}
    >
      <Link href={licenseOriginalMediaUrl} target="_blank">
        <LicensingButton>{children}</LicensingButton>
      </Link>
    </ConnectedTrackedRoute>
  )
}

export default DownloadButton
